'use client';
import { Diamond } from '../SVGs';
import { useTheme } from '../../context/ThemeContext';
import { useState } from 'react';

const DarksideToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleToggle = () => {
    if (!hasInteracted) setHasInteracted(true);
    toggleTheme();
  };

  const getAnimationClass = () => {
    if (!hasInteracted) return ''; // Don't animate on mount

    return theme === 'darkside'
      ? 'animate-spin-shiftX'
      : 'animate-reverse-spin-shiftX';
  };

  return (
    <label className="group relative flex items-center justify-start h-[40px] w-[48px] cursor-pointer bg-none pointer-events-auto">
      <span className="sr-only">
        {theme === 'darkside'
          ? 'Switch to the light side'
          : 'Switch to the dark side'}
      </span>
      <input
        id="darkside-toggle"
        type="checkbox"
        className="absolute left-0 top-0 w-full h-full appearance-none cursor-pointer"
        checked={theme === 'darkside'}
        onChange={handleToggle}
        tabIndex={0}
      />
      <div className={`z-10 absolute origin-center ${getAnimationClass()}`}>
        <Diamond className="overflow-visible group-hover:fill-blank-yellow fill-transparent transition-colors duration-300 ease-in-out" />
      </div>
      <span className="h-[1px] w-[24px] translate-x-[50%] bg-blank-yellow cursor-pointer" />
    </label>
  );
};

export default DarksideToggle;
